export default "__VITE_ASSET__BjwNr43p__"